import { useEffect, useState } from "react";
import { SellerReservationDto } from "../../../api/reservation";
import { DeletePopupWrapper } from "../styles/popup";

interface DeletePopupProps {
  onClose: () => void;
  deleteSelectedReservation: () => void;
  isCheck: (item: SellerReservationDto) => boolean;
  paginatedList: SellerReservationDto[];
  total: number;
}

const DeletePopup = ({
  onClose,
  deleteSelectedReservation,
  isCheck,
  paginatedList,
  total,
}: DeletePopupProps) => {
  const [title, setTitle] = useState<string[]>([]);
  useEffect(() => {
    paginatedList.forEach((item) => {
      if (isCheck(item)) {
        setTitle((prev) => [...prev, item.title]);
      }
    });
  }, []);

  return (
    <DeletePopupWrapper>
      <div className="title">
        {title.map((item, index) => (
          <>
            '{item}'{index !== title.length - 1 && ", "}{" "}
          </>
        ))}
        <br /> 삭제 하시겠습니까?
      </div>
      <div className="button-group">
        <div className="button" onClick={() => onClose()}>
          취소
        </div>
        <div
          className="button red"
          onClick={() => {
            onClose();
            deleteSelectedReservation();
          }}
        >
          삭제
        </div>
      </div>
    </DeletePopupWrapper>
  );
};

export default DeletePopup;
